import { ClassNameProps, Row, StyleProps } from "@hex-insights/core";
import { Badge } from "../../../../../Components/Badge";
import { Icon } from "../../../../../Components/Icon";

export type BooleanBadgeProps = {
	value: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function BooleanBadge({ value, className, style }: BooleanBadgeProps) {
	if (value) {
		return (
			<Badge
				color="var(--brand-colors--primary)"
				backgroundColor="var(--brand-colors--primary--light)"
				className={className}
				style={{ paddingTop: 0, paddingBottom: 0, ...style }}
			>
				<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
					<Icon.Check size={16} /> Yes
				</Row>
			</Badge>
		);
	}

	return (
		<Badge
			color="var(--theme-colors__orange)"
			backgroundColor="var(--theme-colors__orange--background)"
			className={className}
			style={{ paddingTop: 0, paddingBottom: 0, ...style }}
		>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
				<Icon.X size={16} /> No
			</Row>
		</Badge>
	);
}
